import React from 'react';
import PropTypes from 'prop-types';

import * as defaultStyles from '../styles';


export default class MonthsViewHeading extends React.PureComponent {
    static propTypes = {
        year: PropTypes.object.isRequired,
        onNextYear: PropTypes.func.isRequired,
        onPrevYear: PropTypes.func.isRequired,
    };

    static contextTypes = {
        styles: PropTypes.object,
    };

    render() {
        const {year, styles} = this.props;

        return (
            <div className={styles.heading}>
                <span style={{...defaultStyles.button, display: 'inline-block'}}>
                    {(year.format('jYYYY')).persian()}
                </span>
                <button
                    type='button'
                    style={{...defaultStyles.button, float: 'right', width: '2em', height: '2em', minWidth: undefined}}
                    title={window.gettext('Previouse Year')}
                    onClick={this.props.onPrevYear}>
                    <i className='fa-arrow-right'></i>
                </button>
                <button
                    type='button'
                    style={{...defaultStyles.button, float: 'left', width: '2em', height: '2em', minWidth: undefined}}
                    title={window.gettext('Next Year')}
                    onClick={this.props.onNextYear}>
                    <i className='fa-arrow-left'></i>
                </button>
            </div>
        );
    }
}
